export default __webpack_public_path__ + "static/media/LOGO.48633ea5.png";